<template>
  <div id="app">
    <MarketPage></MarketPage>
  </div>
</template>

<script>
import MarketPage from '../components/MarketPage.vue'

export default {
  name: 'Market',
  components: {
    MarketPage
  },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
